import { h } from 'preact';
import { Router } from 'preact-router';
import { Provider, connect } from 'preact-redux';

import ContactPage from './ContactPage';
import GenericPage from './GenericPage';
import BlogIndexPage from './BlogIndexPage';
import BlogPostPage from './BlogPostPage';

import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import Sidebar from '../components/Sidebar';
import HeroImage from '../components/HeroImage';

import { Component } from 'preact';

const App = ({ url, onRouteChange }) => (
    <div>
        <SiteHeader />
        <HeroImage />

        <Router url={url} onChange={onRouteChange}>
            <ContactPage path="/kapcsolat" />
            <GenericPage path="/:path?" />
            <BlogIndexPage path="/blog" />
            <BlogPostPage path="/blog/:postid" />
        </Router>
        <SiteFooter />
    </div>
);

import { loadPageContent } from '../store/index';

import { pageview } from '../client/tracking';

const mapStateToProps = (state, ownProps) => ({
    url: state.currentPath,
    pages
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    onRouteChange: x => {
        if (typeof window === 'object') {
            dispatch(loadPageContent(x.url));
            pageview(x.url);
        }
    }
});

export default connect(state => state, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/components/Application.js